import type { ProductUnitSystem, WeightUnit } from "@kanpla/api-contract";

import {
  convertWeight,
  getPricingBasis,
  isSameUnitSystem
} from "./weight-units";

type Args = {
  unitPrice: number;
  weight: number;
  unitSystem?: ProductUnitSystem;
  weightUnit?: WeightUnit;
};

/**
 * The default is grams rather than the product's own pricing unit: a caller
 * that does not track the scale's unit only ever reads a metric scale, and
 * assuming its unit would price 453 g as 453 lb. A reading from the other
 * system is refused for the same reason (the server refuses it too).
 */
export const calculateUnitPriceByUnitSystem = ({
  unitPrice,
  weight,
  unitSystem,
  weightUnit = "g"
}: Args) => {
  const basis = getPricingBasis(unitSystem);

  if (!basis || !isSameUnitSystem(weightUnit, basis.weightUnit))
    return unitPrice;

  const weightInPricingUnit = convertWeight(
    weight,
    weightUnit,
    basis.weightUnit
  );

  return (unitPrice * weightInPricingUnit) / basis.weightUnitsPerCatalogUnit;
};
